import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { GET_TEMPLATE_WATCHER } from "./constants"
import { getTemplateSuccess, getTemplateFailed } from "./actions"
import { LOCAL_TOKEN } from "../../../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageDestroy() {
  message.destroy()
}

function donwloadTemplate(url) {
  location.replace(url)
}

function getTemplateApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/export/xlsx?template=false`,
  })
}

function getTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/export/xlsx/progress`,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateApiProgress)
      if (data.status === 200) {
        yield call(donwloadTemplate, data.data.data.result[0].url)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(getTemplateSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(getTemplateFailed())
        break
      }
    }
  } catch (e) {
    yield call(messageDestroy)
    returnMessage(e)
    yield put(getTemplateFailed())
  }
}

export default function* leaderSaga() {
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
}
